import { BaseApi } from './base';

class AdminApi extends BaseApi {
  constructor() {
    super('admin');
  }

  getAllPrograms() {
    return this.get('/programs');
  }

  transferMoneyToUser(data) {
    return this.post('/transfer', data);
  }


}

export default new AdminApi();
